import { faCloud, faCode, faDesktop, faMobileAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function Services() {
  return (
    <div className='mt-2'>
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faCode} fontSize={128} className='mb-5 text-danger'/>
            <h2>Software Development Services</h2>
            <p>From desktop applications to mobile apps, we deliver top-notch software solutions using the latest technologies.</p>
        </div>
        <div className='container'>
            <div className='row row-eq-height'>
                <div className='col-lg-4'>
                    <div className='card bg-light p-3'>
                        <FontAwesomeIcon icon={faDesktop} fontSize={64} className="card-img-top m-2 text-danger"/>
                        <div className='card-title text-center'><h3>Desktop Apps</h3></div>
                        <div className='card-body'><p>Streamline your business operations with our expert desktop app development services.</p> </div>
                    </div>
                </div>
                <div className='col-lg-4'>
                <div className='card bg-light p-3'>
                        <FontAwesomeIcon icon={faCloud} fontSize={64} className="card-img-top m-2 text-danger"/>
                        <div className='card-title text-center'><h3>Web Apps</h3></div>
                        <div className='card-body'><p>Revolutionize your online presence with our expert web app development services.</p> </div>
                    </div>
                </div>
                <div className='col-lg-4'>
                    <div className='card bg-light p-3'>
                        <FontAwesomeIcon icon={faMobileAlt} fontSize={64} className="card-img-top m-2 text-danger"/>
                        <div className='card-title text-center'><h3>Mobile Apps</h3></div>
                        <div className='card-body'><p>Unleash the power of mobile with our expert app development services.</p></div>
                    </div>
                </div>
            </div>
        </div>
        <div className='container'>&nbsp;</div>
    </div>
  )
}

export default Services